import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { sponsorshipImages } from '../data/mock';
import { Trophy, Quote } from 'lucide-react';

const Sponsorship = () => {
  const { t } = useLanguage();

  return (
    <section id="sponsorship" className="py-24 bg-[#1e293b]">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="heading-2 text-[#60a5fa] mb-4">{t.sponsorship.title}</h2>
          <p className="body-large text-[#94a3b8] max-w-3xl mx-auto">
            {t.sponsorship.subtitle}
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Images */}
            <div className="grid grid-cols-1 gap-4">
              <div className="relative overflow-hidden border border-[#1e40af] group">
                <img
                  src={sponsorshipImages.nikki1}
                  alt="Nikki Coats British Superbike Champion"
                  className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="relative overflow-hidden border border-[#1e40af] group">
                <img
                  src={sponsorshipImages.nikki2}
                  alt="Nikki Coats racing"
                  className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3 mb-6">
                <Trophy className="w-10 h-10 text-[#60a5fa]" />
                <div>
                  <h3 className="heading-4 text-[#60a5fa]">{t.sponsorship.championName}</h3>
                  <p className="caption text-[#94a3b8]">{t.sponsorship.championTitle}</p>
                </div>
              </div>

              <p className="body-medium text-[#94a3b8] leading-relaxed">
                {t.sponsorship.description}
              </p>

              <div className="bg-[#0f172a] p-6 border-l-4 border-[#60a5fa] relative">
                <Quote className="w-8 h-8 text-[#1e40af] absolute top-4 right-4 opacity-50" />
                <p className="body-small text-[#94a3b8] italic relative z-10">
                  {t.sponsorship.quote}
                </p>
                <p className="caption text-[#60a5fa] mt-4">- {t.sponsorship.championName}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsorship;
